import { useState } from 'react';
import ImageSelectionItem from './ImageSelectionItem';

interface Props {
  images: {
    id: number;
    url: string;
    thumbnail: string;
  }[]
  handleSelected: (id:number, url:string, thumbnail:string) => void
}

const Index = (props: Props) => {
  const { images, handleSelected } = props;

  const [currentId, setCurrentId] = useState(0);

  const handleClick = (id: number, url: string, thumbnail:string) => {
    setCurrentId(id);
    handleSelected(id, url, thumbnail);
  };

  return ((
        <div className="image-imagelist">
            <ul className="imageList">
                { images.map((item) => (<ImageSelectionItem key={item.id} isActive={currentId === item.id} id={item.id} url={item.url} thumbnail={item.thumbnail} handleClick={handleClick} />))}
            </ul>
        </div>
  ));
};

export default Index;
